<template>
  <DBox
    :id="'cmp-booking-artists-sidewindow-artist_booking_list'"
    :addButton="false"
  >
    <div v-if="selectedArtistData && selectedArtistData.bookings" class="ut-fh ut-fc">
      <div class="top-bar">
        <Dropdown
          :options="monthsTV"
          :placeholder="$t('month')"
          :selected="filter.selectedMonth"
          v-on:selectedChange="(e) => onDropdownChange('month', e)"
          deselect
          deselectLabel="Show All Bookings"
        ></Dropdown>
        <Dropdown
          :options="locationsTV"
          :placeholder="$t('venue')"
          :selected="filter.selectedLocation"
          v-on:selectedChange="(e) => onDropdownChange('location', e)"
          deselect
        ></Dropdown>
        <Dropdown
          :options="citiesTV"
          :placeholder="$t('city')"
          :selected="filter.selectedCity"
          v-on:selectedChange="(e) => onDropdownChange('city', e)"
          deselect
        ></Dropdown>
        <Dropdown
          :options="partnersTV"
          :placeholder="$t('promoter')"
          :selected="filter.selectedPartner"
          v-on:selectedChange="(e) => onDropdownChange('partner', e)"
          deselect
        ></Dropdown>
        <Dropdown
          :options="promotersTV"
          :placeholder="$t('contact_promoter')"
          :selected="filter.selectedPromoter"
          v-on:selectedChange="(e) => onDropdownChange('promoter', e)"
          deselect
        ></Dropdown>
      </div>
      <div class="ut-fh ut-fc">
        <NTable
          class="dbox1"
          id="booking-artists-artists_sidewindow-related_bookings"
          :items="selectedArtistData.bookings"
          :headers="headers"
          :config="tableConfig"
          @scrollnext="onArtistBookingsNext"
        >
          <template v-slot:item="{ item, tdcon }">
            <!-- <tr @click="e => onBookingClick(item)"> -->
            <tr style="cursor: pointer;">
              <td v-bind="tdcon('start_date')">
                <span
                  @click.stop="(e) => onBookingClick(item)"
                  class="txtov ut-link ut-text-accent5"
                  >{{ item["start_date"] }}</span
                >
              </td>
              <td v-bind="tdcon('booking_status_colour')">
                <!-- <div
                  class="colored-box ut-center ut-link"
                  :style="{
                    'background-color': '#' + item['booking_status_colour']
                  }"
                ></div> -->
                <div
                  class="circle-status"
                  :style="{
                    backgroundColor: `#${item['booking_status_colour']}`,
                  }"
                ></div>
              </td>
              <td v-bind="tdcon('venue')">
                <span class="txtov">{{ item["booking_location_name"] }}</span>
              </td>
              <td v-bind="tdcon('city')">
                <span class="txtov">{{ item["city"] }}</span>
              </td>
              <td v-bind="tdcon('promoter')">
                <div class="ut-flex ut-fw-20">
                  <div
                    @click.stop="(e) => onSelectPromoter(item)"
                    class="ut-mx-auto txtov ut-link ut-text-accent5"
                  >
                    {{ getSubmenuPromoterName(item) }}
                  </div>
                  <img
                    v-if="item['partner_email']"
                    src="static/icons/email/email-grey.svg"
                    class="dt-icon v5 s1"
                    @click.stop="(e) => onMailClick(item['partner_email'])"
                    :alt="$t('email_partner')"
                    :title="$t('email_partner')"
                  />
                </div>
              </td>
              <td v-bind="tdcon('contact_promoter')">
                <div class="ut-flex">
                  <div
                    @click.stop="(e) => onSelectContactPromoter(item)"
                    class="ut-mx-auto txtov ut-link ut-text-accent5"
                  >
                    {{ getContactPromoterName(item) }}
                  </div>
                  <img
                    v-if="item['promoter_email']"
                    src="static/icons/email/email-grey.svg"
                    class="dt-icon v5 s1"
                    @click.stop="(e) => onMailClick(item['promoter_email'])"
                    :alt="$t('email_promoter')"
                    :title="$t('email_promoter')"
                  />
                </div>
              </td>
              <td v-bind="tdcon('deal_memo')">
                <span class="txtov">{{ item["first_offer_notes"] }}</span>
              </td>
            </tr>
          </template>
        </NTable>
      </div>
    </div>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import { mapActions } from "vuex";
import { BookingStoreNamespace as storeNS } from "../../../store";
import * as ActionTypes from "../../../store/types";
import {
  bookingListCalendarDateTabRoute,
  bookingPromoterDetailsTabRoute,
  bookingVenueRoutes,
} from "../../../router/router";
import {
  encodeRoute,
  createMailHref,
  capitalizeFirst,
  subscribeSubjectND,
} from "../../../../../utility";

import {
  createNTableConfig,
  createTableHeader,
} from "../../../../../plugins/datatable";
import { isEmpty } from "ramda";
import { contactListLDTRoutes } from "../../../../contacts/router/routes";
import { Subject } from "rxjs";
import { LoadedEnd } from "../../../../../dt-plugins/advanced-search/load.model";

export default {
  components: {
    DBox,
    NTable,
  },
  props: {
    selectedArtistData: {
      type: Object,
      required: true,
    },
    selectedArtist: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
      filter: {
        selectedMonth: null,
        selectedLocation: null,
        selectedCity: null,
        selectedPromoter: null,
        selectedPartner: null,
      },
      start: 0,
      row_count: 100,
      loadedStart: 0,
      scrollSubject$: new Subject(),
      loadedEnd: false,
      loadingFlag: false,
    };
  },
  computed: {
    monthsTV: function () {
      return this.selectedArtistData.months.map((e) => ({
        text: `${capitalizeFirst(e.month)} ${e.year}`,
        value: e.month_val,
      }));
    },
    locationsTV: function () {
      return this.selectedArtistData.locations.map((e) => ({
        text: e.booking_location_name,
        value: e.booking_location_name,
      }));
    },
    citiesTV: function () {
      return this.selectedArtistData.cities.map((e) => ({
        text: e.city,
        value: e.city,
      }));
    },
    promotersTV: function () {
      return this.selectedArtistData.promoters.map((e, i) => ({
        text: e.company_name
          ? e.company_name
          : `${e.first_name} ${e.last_name}`,
        value: e.company_name
          ? e.company_name
          : `${e.first_name} ${e.last_name}`,
      }));
    },
    partnersTV: function () {
      return this.selectedArtistData.partners.map((e, i) => ({
        text: e.company_name
          ? e.company_name
          : `${e.first_name} ${e.last_name}`,
        value: `${i}`,
      }));
    },
    filterObject: function () {
      console.log(
        {
          month: this.filter.selectedMonth,
          location: this.filter.selectedLocation,
          city: this.filter.selectedCity,
          partner: this.filter.selectedPartner,
          promoter: this.filter.selectedPromoter,
        },
        {
          month: this.filter.selectedMonth
            ? this.filter.selectedMonth.value
            : "",
          location: this.filter.selectedLocation
            ? this.filter.selectedLocation.value
            : "",
          city: this.filter.selectedCity ? this.filter.selectedCity.value : "",
          partner: this.filter.selectedPartner
            ? this.filter.selectedPartner.text
            : "",
          promoter: this.filter.selectedPromoter
            ? this.filter.selectedPromoter.text
            : "",
        }
      );
      return {
        month: this.filter.selectedMonth ? this.filter.selectedMonth.value : "",
        location: this.filter.selectedLocation
          ? this.filter.selectedLocation.value
          : "",
        city: this.filter.selectedCity ? this.filter.selectedCity.value : "",
        partner: this.filter.selectedPartner
          ? this.filter.selectedPartner.text
          : "",
        promoter: this.filter.selectedPromoter
          ? this.filter.selectedPromoter.text
          : "",
      };
    },
    headers: function () {
      return [
        createTableHeader("start_date", { text: false }),
        createTableHeader("booking_status_colour", { text: false, f: 0.25 }),
        createTableHeader("venue"),
        createTableHeader("city"),
        createTableHeader("promoter"),
        createTableHeader("contact_promoter"),
        createTableHeader("deal_memo")
      ];
    },
    venue_id: function () {
      return this.$route.params.venue_id;
    },
  },
  mounted: function () {
    subscribeSubjectND(this, this.scrollSubject$, (scrollTop) => {
      if (this.start == this.loadedStart) {
        this.start += this.row_count;
        this.fetchListNext();
      }
    });
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.NEXT_ARTIST_BOOKINGS]: ActionTypes.NEXT_ARTIST_BOOKINGS
    }),
    onBookingClick: function (booking) {
      this.$router.push({
        name: bookingListCalendarDateTabRoute,
        params: {
          calendar_date_id: booking.calendar_date_id,
          tab: "overview",
        },
        query: {
          from: encodeRoute(this.$route),
        },
      });
    },
    onSelectContactPromoter: function (selectedBooking) {
      console.log("contactPromoter ", selectedBooking);
      this.$router.push({
        name: contactListLDTRoutes.names.tab,
        params: {
          contact_id: selectedBooking.promoter_contact_id,
          tab: "overview",
        },
      });
    },
    onSelectPromoter: function (selectedBooking) {
      console.log("selectPromoter ", selectedBooking);
      // this.$router.push({
      //   name: bookingPromoterDetailsTabRoute,
      //   params: {
      //     promoter_id: selectedBooking.partner_contact_id,
      //     tab: "overview"
      //   }
      // });

      this.$router.push({
        name: contactListLDTRoutes.names.tab,
        params: {
          contact_id: selectedBooking.partner_contact_id,
          tab: "overview",
        },
      });
    },
    onMailClick: function (mail) {
      location.href = createMailHref({
        mails: [mail],
      });
    },
    onDropdownChange: function (name, value) {
      console.log(name, value);
      if (isEmpty(value)) {
        value = undefined;
      }
      switch (name) {
        case "month": {
          this.filter.selectedMonth = value;
          break;
        }
        case "location": {
          this.filter.selectedLocation = value;
          break;
        }
        case "city": {
          this.filter.selectedCity = value;
          break;
        }
        case "partner": {
          this.filter.selectedPartner = value;
          break;
        }
        case "promoter": {
          this.filter.selectedPromoter = value;
          break;
        }
      }
      this.emitFilter();
    },

    emitFilter: function () {
      this.$emit("filter", this.filterObject);
    },

    getSubmenuPromoterName(item) {
      return item["partner_first_name"]
        ? `${item["partner_first_name"] || ""} ${
            item["partner_last_name"] || ""
          }`
        : `${item["partner_company_name"] || ""}`;
    },

    getContactPromoterName(item) {
      return item["promoter_first_name"]
        ? `${item["promoter_first_name"] || ""} ${
            item["promoter_last_name"] || ""
          }`
        : `${item["promoter_company_name"] || ""}`;
    },
    onArtistBookingsNext: function () {
      this.scrollSubject$.next();
    },
    fetchListReset: function () {
      this.start = 0;
      this.loadedStart = 0;
      this.loadedEnd = false;
      this.fetchList();
    },
    fetchList: async function () {
      if (this.loadedEnd === false) {
        this.loadingFlag = true;

        const loadStatus = await this[ActionTypes.NEXT_ARTIST_BOOKINGS]({
          offset: this.start,
          artistId: this.selectedArtist.artist_id
        });

        if (loadStatus === LoadedEnd) {
          this.loadedEnd = true;
        }
        this.loadingFlag = false;
      }
    },
    fetchListNext: async function () {
      await this.fetchList();
      this.loadedStart = this.start;
    },
  },
};
</script>

<style lang="scss">
.cmp-booking-artists-sidewindow-artist_booking_list {
  .top-bar {
    display: flex;

    .dropdown {
      flex: 1;
      margin: 5px;
    }
  }

  .dt-ntable {

    td.promoter,
    td.contact_promoter {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      span {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }

    .booking_status_colour {
      .colored-box {
        width: 15px;
        height: 15px;
      }
    }
  }

  .dropdown {
    .dropdown--main {
      border-bottom: 1px solid var(--sprt-5);
    }
  }
}
</style>
